import { appStore } from '@store';
import {
	IAnalyticsEventsTracker,
	IAnalyticsTargetedEventsTracker,
	TargetedEventsTracker,
	FacebookEventsTracker,
	GTMEventsTracker,
	PinterestEventsTracker,
	TargetedConsoleLogEventsTracker,
} from '@verv-inc/js-toolkit';

import { EVENT_TRACKERS } from './types';
import { VervBIEventsTracker } from './VervBIEventsTracker';
import { IExtraDataPromocode } from 'types';
import { IVervAPIServices } from 'utils/services/VervAPI';

export const composeAnalyticsEventsTracker = (
	VervAPI: IVervAPIServices,
): IAnalyticsTargetedEventsTracker => {
	const trackersMap = new Map<EVENT_TRACKERS, IAnalyticsEventsTracker>();

	trackersMap.set(EVENT_TRACKERS.GTM, GTMEventsTracker());
	trackersMap.set(EVENT_TRACKERS.Facebook, FacebookEventsTracker());
	trackersMap.set(EVENT_TRACKERS.Pinterest, PinterestEventsTracker());

	const vervBITracker = VervBIEventsTracker({
		api: VervAPI,
		bundleID: 'verv',
		extraDataPromocodeLifeInterval: process.env.REACT_APP_EXTRADATA_PROMOCODE_LIFE_INTERVAL
			? +process.env.REACT_APP_EXTRADATA_PROMOCODE_LIFE_INTERVAL
			: 82822000,
		getStateData: () => {
			const { extraDataPromocode, sourceLocation } = appStore;
			return {
				extraDataPromocode,
				sourceLocation: sourceLocation ?? window.location,
			};
		},
		updateStateData: (extraDataPromocode: IExtraDataPromocode | null) => {
			const { setExtraDataPromocode } = appStore;
			if (extraDataPromocode?.promocode) {
				setExtraDataPromocode(extraDataPromocode);
			}
		},
	});
	trackersMap.set(EVENT_TRACKERS.VervBI, vervBITracker);

	const targetedEventsTracker = TargetedEventsTracker(trackersMap);

	if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
		return TargetedConsoleLogEventsTracker(targetedEventsTracker);
	}

	return targetedEventsTracker;
};
